$(document).ready(() => {
  const $el = $('.r7-hero__countdown');
  const $desc = $('.r7-hero__description');
  const date = new Date($el.data('countdown')).getTime();
  function addZero(num, size) {
    let s = `${num}`;
    while (s.length < size) s = `0${s}`;
    return s;
  }
  if (date - new Date().getTime() < 0) {
    $desc.show(0);
  } else {
    $el.show(0);

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = date - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      $el
        .find('span')
        .html(
          `${addZero(days, 2)} | ${addZero(hours, 2)} : ${addZero(
            minutes,
            2
          )} : ${addZero(seconds, 2)}`
        );

      if (distance < 0) {
        $el.hide(0);
        $desc.show(0);
        clearInterval(interval);
      }
    }, 1000);
  }
});
